<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="评论" text="评论列表">
          <v-layout row wrap class="mx-3">
            <v-layout row wrap xs12>
              <v-flex sm3>
                <v-text-field hide-details label="书名" v-model="searchBookName"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field hide-details label="漂流链名称" v-model="searchLinkName"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field hide-details label="昵称" v-model="searchNickName"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field hide-details label="关键字查询" v-model="searchBody"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-dialog
                  ref="dialog"
                  v-model="dateDialog"
                  :return-value.sync="searchDate"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <v-date-picker v-model="searchDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="dateDialog = false">取消</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(searchDate)">确定</v-btn>
                  </v-date-picker>
                </v-dialog>

                <v-text-field
                  hide-details
                  label="创建时间"
                  v-model="searchDate"
                  @click="dateDialog=true"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-select
                  v-model="searchStatus"
                  hide-details
                  :items="commentStatuses"
                  item-text="name"
                  item-value="value"
                  label="评论状态"
                ></v-select>
              </v-flex>
              <v-flex sm3 class="text-no-wrap">
                <v-btn color="orange" dark class="mx-2" @click="onClickReset">重置</v-btn>
                <v-btn color="green" dark @click="onClickSearch">查询</v-btn>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :pagination.sync="pagination"
                :rows-per-page-items="rowsPerPageItems"
                :disable-initial-sort="true"
              >
                <template slot="headerCell" slot-scope="{ header }">
                  <span
                    class="subheading font-weight text-success text--darken-3"
                    v-text="header.text"
                  />
                </template>
                <template slot="items" slot-scope="{ item }">
                  <td>{{ item.id }}</td>
                  <td>《{{ item.bookName }}》</td>
                  <td>{{ item.linkName }}</td>
                  <td>
                    <img :src="item.avatarUrl" class="avatar">
                    {{ item.nickName }}
                  </td>
                  <td>{{ item.mobile }}</td>
                  <!-- <td>{{ formateDate(item.joinTime) }}</td> -->
                  <td>{{ item.body }}</td>
                  <td>{{ formateDate(item.createdAt) }}</td>
                  <td :class="{'red--text': item.status === -1}">{{ getStatusName(item) }}</td>
                  <td class="text-no-wrap">
                    <v-chip
                      v-if="item.status === -1"
                      small
                      color="green"
                      text-color="white"
                      class="pointer"
                      @click="onClickEnable(item)"
                    >恢复</v-chip>
                    <v-chip
                      v-else
                      small
                      color="red"
                      text-color="white"
                      class="pointer"
                      @click="onClickDisable(item)"
                    >屏蔽</v-chip>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
.avatar {
  border-radius: 50%;
  width: 28px;
  height: 28px;
}
.pointer {
  cursor: pointer;
}
</style>


<script>
import dayjs from 'dayjs'
import global from '@/global'
import { getCommentsByPage, enableComment, disableComment } from '@/services'

export default {
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id'
      },
      {
        text: '书名',
        value: 'bookName'
      },
      {
        text: '漂流链名称',
        value: 'linkName'
      },
      // {
      //   text: '',
      //   sortable: false
      // },
      {
        text: '昵称',
        value: 'nickName'
      },
      {
        text: '手机号',
        value: 'mobile'
      },
      // {
      //   text: '加入时间',
      //   value: 'joinTime'
      // },
      {
        text: '评论内容',
        value: 'body'
      },
      {
        text: '评论时间',
        value: 'createdAt'
      },
      {
        text: '状态',
        value: 'status'
      },
      {
        text: '操作',
        sortable: false
      }
    ],
    items: [],
    rowsPerPageItems: [2, 5, 10, 20, 50],
    pagination: {
      page: 1,
      rowsPerPage: 5,
      descending: false,
      sortBy: null
    },
    criteria: [],
    searchBookName: null,
    searchLinkName: null,
    searchNickName: null,
    searchBody: null,
    searchDate: null,
    searchStatus: null,
    dateDialog: false,
    commentStatuses: [
      {
        name: '正常',
        value: 0
      },
      {
        name: '屏蔽',
        value: -1
      }
    ]
  }),

  computed: {
    tempParams() {
      return {
        descending: this.pagination.descending || null,
        page: this.pagination.page || null,
        rowsPerPage: this.pagination.rowsPerPage || null,
        sortBy: this.pagination.sortBy || null
      }
    },

    totalItems() {
      return (this.pagination && this.pagination.totalItems) || 0
    }
  },

  watch: {
    tempParams: {
      async handler(oldValue, newValue) {
        // console.log('oldValue', JSON.stringify(oldValue))
        if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
          return
        }
        // console.log('newValue', JSON.stringify(newValue))
        await this.fetchData()
      }
    }
  },

  async beforeMount() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      let pagination = await getCommentsByPage({
        ...this.pagination,
        criteria: this.criteria
      })

      if (pagination) {
        // remove items from pagination
        this.pagination = { ...pagination, items: [] }
        this.items = pagination.items
      }
    },

    formateDate(x) {
      return dayjs(x).format('YYYY-MM-DD HH:mm')
    },

    async onClickSearch() {
      let criteria = []
      if (this.searchBookName) {
        criteria.push({
          name: 'bookName',
          op: 'like',
          value: `%${this.searchBookName.replace(/《|》/g, '').trim()}%`
        })
      }

      if (this.searchLinkName) {
        criteria.push({
          name: 'linkName',
          op: 'like',
          value: `%${this.searchLinkName}%`
        })
      }

      if (this.searchNickName) {
        criteria.push({
          name: 'nickName',
          op: 'like',
          value: `%${this.searchNickName}%`
        })
      }

      if (this.searchBody) {
        criteria.push({
          name: 'body',
          op: 'like',
          value: `%${this.searchBody}%`
        })
      }

      if (this.searchStatus >= -1) {
        criteria.push({
          name: 'status',
          op: '=',
          value: this.searchStatus
        })
      }

      if (this.searchDate) {
        criteria.push({
          name: 'createdAt',
          op: 'between',
          value: dayjs(this.searchDate).format('YYYY-MM-DD'),
          value2: dayjs(this.searchDate).format('YYYY-MM-DD 23:59:59')
        })
      }

      this.criteria = criteria
      await this.fetchData()
    },

    async onClickReset() {
      this.criteria = []
      this.searchBookName = null
      this.searchLinkName = null
      this.searchNickName = null
      this.searchBody = null
      this.searchDate = null
      this.searchStatus = null
      await this.fetchData()
    },

    async onClickEnable(item) {
      let res = await enableComment(item.id)
      if (res) {
        item.status = res.status
        global.showSuccess('恢复成功')
      }
    },

    async onClickDisable(item) {
      let res = await disableComment(item.id)
      if (res) {
        item.status = res.status
        global.showError('已屏蔽')
      }
    },

    getGenderIcon(item) {
      if (item.gender === 1) {
        return 'mdi-gender-male'
      }
      if (item.gender === 2) {
        return 'mdi-gender-female'
      }
      return ''
    },

    getStatusName(item) {
      if (item.status === -1) {
        return '已屏蔽'
      }
      return '正常'
    }
  }
}
</script>
